import script from "./FloraAutoctonaView.vue?vue&type=script&setup=true&lang=js"
export * from "./FloraAutoctonaView.vue?vue&type=script&setup=true&lang=js"

import "./FloraAutoctonaView.vue?vue&type=style&index=0&id=8b126e58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b126e58"]])

export default __exports__